module.exports = __webpack_public_path__ + "static/media/sliders.052f85cd.svg";